import { Component } from '@angular/core';
import { AppSidebar } from 'app/main/models/sidebar';
import { CountryService } from 'app/main/services/country.service';
import { NotificationService } from 'app/main/services/notifications.service';
import { SidebarService } from 'app/main/services/sidebar.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-notifications-list',
  templateUrl: './notifications-list.component.html',
  styleUrls: ['./notifications-list.component.scss'],
})
export class NotificationsListComponent {
  public contentHeader: object;
  public notifications: any[] = [];
  constructor(public _notifications: NotificationService) {}

  ngOnInit(): void {
    this.getNotifications();
  }

  getNotifications = () =>
    this._notifications.getAll().subscribe((res) => {
      this.notifications = res;
    });

  readNotification = (id: number) => this._notifications.readNotification(id);
}
